"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameValidationError = exports.USER_AUTHENTICATED_WITH_GOOGLE_SSO = exports.VERIFY_GOOGLE_STYTCH_CALLBACK_INVALID_EMAIL = void 0;
exports.VERIFY_GOOGLE_STYTCH_CALLBACK_INVALID_EMAIL = "verify_google_stytch_callback_invalid_email";
exports.USER_AUTHENTICATED_WITH_GOOGLE_SSO = "userAuthenticatedWithGoogleSSO";
var NameValidationError;
(function (NameValidationError) {
    NameValidationError["INVALID_FIRST_NAME"] = "INVALID_FIRST_NAME";
    NameValidationError["INVALID_LAST_NAME"] = "INVALID_LAST_NAME";
})(NameValidationError || (exports.NameValidationError = NameValidationError = {}));
